import { render, staticRenderFns } from "./CommentLine.vue?vue&type=template&id=09a2b38f&scoped=true&"
import script from "./CommentLine.vue?vue&type=script&lang=js&"
export * from "./CommentLine.vue?vue&type=script&lang=js&"
import style0 from "./CommentLine.vue?vue&type=style&index=0&id=09a2b38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2b38f",
  null
  
)

export default component.exports